import { render, staticRenderFns } from "./ClientVerticalMenu.vue?vue&type=template&id=7353c469&scoped=true"
import script from "./ClientVerticalMenu.vue?vue&type=script&lang=js"
export * from "./ClientVerticalMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7353c469",
  null
  
)

export default component.exports